<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4532 21.0938H7.72488C7.10214 21.093 6.50512 20.8453 6.06478 20.4049C5.62443 19.9646 5.37672 19.3676 5.37598 18.7448V4.59891C5.37672 3.97617 5.62443 3.37914 6.06478 2.9388C6.50512 2.49846 7.10214 2.25074 7.72488 2.25H14.7608C14.9472 2.25004 15.1259 2.32405 15.2577 2.45578L20.5958 7.79391C20.6612 7.85919 20.713 7.93672 20.7484 8.02205C20.7838 8.10739 20.8021 8.19887 20.8021 8.29125V18.7444C20.8014 19.3672 20.5538 19.9643 20.1134 20.4048C19.6731 20.8452 19.076 21.093 18.4532 21.0938ZM7.72488 3.65625C7.47495 3.6565 7.23533 3.75589 7.0586 3.93262C6.88187 4.10935 6.78247 4.34897 6.78223 4.59891V18.7448C6.78247 18.9948 6.88187 19.2344 7.0586 19.4111C7.23533 19.5879 7.47495 19.6873 7.72488 19.6875H18.4532C18.7031 19.6873 18.9427 19.5879 19.1194 19.4111C19.2962 19.2344 19.3956 18.9948 19.3958 18.7448V8.58234L14.4693 3.65625H7.72488Z"
      :fill="iconColor"
    />
    <path
      d="M20.0988 8.99438H16.406C15.7833 8.99363 15.1863 8.74592 14.7459 8.30557C14.3056 7.86523 14.0579 7.26821 14.0571 6.64547V2.95312C14.0571 2.76664 14.1312 2.5878 14.2631 2.45594C14.3949 2.32408 14.5738 2.25 14.7603 2.25C14.9467 2.25 15.1256 2.32408 15.2574 2.45594C15.3893 2.5878 15.4634 2.76664 15.4634 2.95312V6.64547C15.4636 6.8954 15.563 7.13502 15.7397 7.31175C15.9165 7.48848 16.1561 7.58788 16.406 7.58813H20.0984C20.2849 7.58813 20.4637 7.6622 20.5956 7.79407C20.7274 7.92593 20.8015 8.10477 20.8015 8.29125C20.8015 8.47773 20.7274 8.65657 20.5956 8.78843C20.4637 8.9203 20.2849 8.99438 20.0984 8.99438H20.0988Z"
      :fill="iconColor"
    />
    <path
      d="M8.0625 12.5325C8.0625 12.3774 8.20312 12.241 8.4225 12.241H9.70313C10.522 12.241 11.1675 12.6258 11.1675 13.6683V13.6992C11.1675 14.7417 10.4972 15.1388 9.64078 15.1388H9.02813V16.4789C9.02813 16.6777 8.78625 16.7766 8.54391 16.7766C8.30156 16.7766 8.0625 16.6777 8.0625 16.4789V12.5325ZM9.03047 13.0847V14.3939H9.64453C9.99188 14.3939 10.2033 14.1957 10.2033 13.7738V13.7053C10.2033 13.2835 9.99188 13.0847 9.64453 13.0847H9.03047Z"
      :fill="iconColor"
    />
    <path
      d="M13.1102 12.241C13.9667 12.241 14.637 12.638 14.637 13.7053V15.3127C14.637 16.3796 13.9667 16.7766 13.1102 16.7766H12.012C11.7579 16.7766 11.5901 16.6402 11.5901 16.485V12.5325C11.5901 12.3774 11.7579 12.241 12.012 12.241H13.1102ZM12.5581 13.0847V15.9328H13.1102C13.4581 15.9328 13.669 15.7346 13.669 15.3127V13.7053C13.669 13.2835 13.4581 13.0847 13.1102 13.0847H12.5581Z"
      :fill="iconColor"
    />
    <path
      d="M15.2512 12.5391C15.2512 12.3403 15.4621 12.241 15.6731 12.241H17.826C18.0309 12.241 18.1181 12.4585 18.1181 12.6567C18.1181 12.8864 18.0126 13.0847 17.826 13.0847H16.2187V14.1338H17.1562C17.3437 14.1338 17.4478 14.3133 17.4478 14.5121C17.4478 14.6794 17.361 14.8782 17.1562 14.8782H16.2187V16.4789C16.2187 16.6777 15.9768 16.7766 15.735 16.7766C15.4931 16.7766 15.2507 16.6777 15.2507 16.4789L15.2512 12.5391Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPdf",
  props: {
    iconName: {
      type: String,
      default: "iconPdf",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
